import { CancelToken } from 'axios'
import ApiErrors from '@/services/ApiErrors/ApiErrors'

class ApiRequest {
  constructor (requestFn, Model, options) {
    this.Model = Model
    this.error = null
    this.data = null
    this.summary = null
    this.loading = false
    this.options = options
    this.cancelFn = () => {}
    this.requestFn = requestFn
  }

  formatArguments (args) {
    return args
  }

  setError (error) {
    this.error = error
  }

  setLoading (loading) {
    this.loading = loading
  }

  setData (data) {
    this.data = data
  }

  setSummary (summary) {
    if (summary != null) {
      this.summary = summary
    }
  }

  setCancelFn (cancelFn) {
    this.cancelFn = cancelFn
  }

  clearData () {
    this.setData(null)
  }

  clearSummary () {
    this.setSummary(null)
  }

  parsePayload (payload) {
    if (this.Model == null) {
      return payload
    }

    if (Array.isArray(payload)) {
      return payload.map((data) => new this.Model(data))
    }

    return new this.Model(payload)
  }

  cancel () {
    this.cancelFn()
  }

  handleResponse ({ payload, summary }) {
    this.setData(this.parsePayload(payload))
    this.setSummary(summary)
    this.setLoading(false)

    return this.data
  }

  handleError (error) {
    const apiErrors = new ApiErrors(error)

    this.setLoading(false)

    if (!apiErrors.isRequestCancelled) {
      this.clearData()
      this.clearSummary()
      this.setError(apiErrors)
    }

    throw apiErrors
  }

  execute (...args) {
    if (this.cancelFn != null) {
      this.cancel()
    }

    this.setError(null)
    this.setLoading(true)

    return this.requestFn(...this.formatArguments(args), {
      ...this.options,
      cancelToken: new CancelToken(this.setCancelFn.bind(this))
    })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }
}

export default ApiRequest
